// ForgotPasswordForm.jsx
import axios from 'axios';
import { useState } from 'react';
import BASE_URL from '../../config';
import './forgotPassword.css';

export default function ForgotPasswordForm() {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${BASE_URL}/api/forgot-password/`, { email });
      setMsg(res.data.message || res.data.error);
    } catch (error) {
      setMsg('An error occurred. Please try again.');
    }
  };

  return (
    <div className="forgot-password-container">
      <form className="forgot-password-form" onSubmit={handleSubmit}>
        <h2>Forgot Password</h2>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <button type="submit">Send Reset Link</button>
        {msg && <p className="fp-form-message">{msg}</p>}
      </form>
    </div>
  );
}
